import { get } from './lodash';

/**
 * @deprecated 判断设备环境时，PC 应使用 ~/utils 的 isMobileUA()，平台 SDK 内使用 globalState.isMobile。
 * 按视口宽度调整布局时可使用该方法
 */
export const isMobileLayout = () => window.innerWidth < 768;

/**
 * 是否为iframe
 *
 * @returns
 */
export const inIframe = () => {
    return window.self !== window.top;
};

/**
 * 判断postMessage的消息是否来自目标iframe
 * 通用判断，主要是为了防止钉钉环境下会给真正的iframe包在event.source[0] 里的问题
 * 主要针对那些没有明确POST_MESSAGE_KEY来标识来源的场景
 * @param event MessageEvent
 * @param targetIFrame 目标iframe
 * @see FXD-70439 FXD-74113
 */
export const isMessageFromTargetIFrame = (
    event: MessageEvent,
    targetIFrame: Window | null | undefined
) => {
    if (!event || !targetIFrame) {
        return false;
    }

    if (targetIFrame === event.source) {
        return true;
    }

    const unwrappedSource = get(event, 'source.0', null);
    return targetIFrame === unwrappedSource;
};

/**
 * 获取客户端/设备主题
 */
export const getSystemTheme = () => {
    if (window.matchMedia('(prefers-color-scheme: dark)')?.matches) {
        return 'dark';
    }

    if (window.matchMedia('(prefers-color-scheme: light)')?.matches) {
        return 'light';
    }

    return '';
};
